interface ObsidianEvents {
  "ow:api-unauthenticated-response": CustomEvent<null>;
}

type ObsidianEventType = keyof ObsidianEvents;

type MapEventTypeToDetail<TEvent extends ObsidianEventType> =
  ObsidianEvents[TEvent] extends CustomEvent<infer TEventDetail>
    ? TEventDetail
    : never;

type ObsidianEventInit<TEventDetail> = Omit<CustomEventInit, "detail"> & {
  detail: TEventDetail;
};

export class ObsidianEvent<
  TEventType extends keyof ObsidianEvents,
> extends CustomEvent<MapEventTypeToDetail<TEventType>> {
  constructor(
    type: TEventType,
    init: ObsidianEventInit<MapEventTypeToDetail<TEventType>>,
  ) {
    super(type, init);
  }
}

declare global {
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  interface WindowEventMap extends ObsidianEvents {}
}
